import { Box, Icon, Text, useColorModeValue } from '@chakra-ui/react';

import Card from 'components/card/Card';

import Dropzone from 'components/dropzone/Dropzone';

import { MdOutlineCloudDownload } from 'react-icons/md';

const DropzoneCard = ({
  handleFileUpload,
  isLoading,
}: {
  handleFileUpload: (files: File[]) => void;
  isLoading: boolean;
}) => {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const brand = useColorModeValue('brand.500', 'brand.400');

  return (
    <Card>
      <Dropzone
        isLoading={isLoading}
        handleFileUpload={handleFileUpload}
        content={
          <Box>
            {!isLoading && (
              <Icon
                as={MdOutlineCloudDownload}
                w="60px"
                h="60px"
                color={textColor}
              />
            )}

            <Text
              mb="12px"
              fontSize="lg"
              w="100%"
              maxW="100%"
              fontWeight="700"
              color={textColor}
              whiteSpace="pre-wrap"
            >
              Drag and drop your files here, or{' '}
              <Text as="span" fontWeight="700" color={brand}>
                click to browse
              </Text>
            </Text>
          </Box>
        }
      />
    </Card>
  );
};

export default DropzoneCard;
